module.exports = __webpack_public_path__ + "static/media/YF66_1.0083b115.jpg";